import React from 'react'

const SocietyHeading = ({ children }) => (
  <div className="flex justify-between my-4 text-4xl text-gray-700 font-amatic">
    {children}
  </div>
)

export default SocietyHeading
